// REQUIREMENTS:
// must load library > ajax.js prior to this file in the bundle
// video links on the page must have: 
//    - the class "videoLink"
//    - a title with the name of the product
//    - data-productid attribute 

var videos4i = function() {
	const azureMediaPlayerPath = '//amp.azure.net/libs/amp/2.3.0/azuremediaplayer.min.js';
	const azureMediaPlayerSkinPath = '//amp.azure.net/libs/amp/2.3.0/skins/amp-flush/azuremediaplayer.min.css';
	var allVideoLinks = [].slice.call(document.getElementsByClassName("videoLink"));
	var isDialog = document.getElementById("videoDialog");
	var videoPlayer, triggerEl;
	var videoOptions = {
		autoplay: true,
		controls: true,
		logo: { enabled: false },
		techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"]
	},
		initWhyBuyVideo = function() {
			var whyBuyPlayer = amp("azuremediaplayer", videoOptions);
			var whyBuyVideoUrl = '//4imprintvideo.streaming.mediaservices.windows.net/fbe158df-f8ed-4f36-b424-6be8f8f0e93d/AboutUs_FINAL_1080_1-9-18.ism/manifest';
			var whyBuyVideoCaptionsUrl = '//4imprintvideo.blob.core.windows.net/asset-ae46025c-18ee-438c-9d25-d42d4ee6b7c6/AboutUs_FINAL_1080_1-9-18.mp4.vtt';
			whyBuyPlayer.src([
				{ src: whyBuyVideoUrl }
			], [
				{ src: whyBuyVideoCaptionsUrl, srclang: "en", kind: "subtitles", label: "English" }
			]);
		},
		initWeBelieveVideo = function() {
			var weBelievePlayer = amp("azuremediaplayer", videoOptions);
			var weBelieveVideoUrl = '//4imprintvideo.streaming.mediaservices.windows.net/ffec2f89-5d74-4395-8691-65307130f095/we-believe-2015.ism/Manifest';
			var weBelieveVideoCaptionsUrl = '//4imprintvideo.blob.core.windows.net/asset-3fdf6068-25e8-4e30-a272-350aa4b24f84/we-believe-2015.mp4.vtt';
			weBelievePlayer.src([
				{ src: weBelieveVideoUrl }
			], [
				{ src: weBelieveVideoCaptionsUrl, srclang: "en", kind: "subtitles", label: "English" }
			]);
		},
		closeDialog = function(e) {
			e.preventDefault();
			videoPlayer.dispose();
			triggerEl.focus();
			if (triggerEl.hasAttribute("aria-haspopup")) {
				triggerEl.setAttribute("aria-expanded", "false");
				isDialog.setAttribute("aria-hidden", "true");
			}
		},
		initLinks = function() {
			allVideoLinks = [].slice.call(document.getElementsByClassName("videoLink"));
			allVideoLinks.forEach(function(el, index, array) {
				el.addEventListener("click", function(e) {
					e.preventDefault();
					getTheVideo(el);
				});
				el.addEventListener("keyup", function(e) {
					if (e.which == 13) { //enter
						el.click();
					}
				});
			});
		},
		initDynamicLink = function(el) {
			getTheVideo(el);
		},
		getTheVideo = function(videoLink) {
			var vidTitle, productVideoDialog;
			triggerEl = videoLink;
			if (isDialog) {
				productVideoDialog = dialog4i();
				vidTitle = triggerEl.getAttribute("title");
				triggerEl.setAttribute("aria-expanded", "true");
				isDialog.setAttribute("aria-hidden", "false");
			}
			var productID = triggerEl.getAttribute("data-productid");
			var controllerUrl = "/video/videodetails/" + productID;

			var getVideoData = ajax({
				method: "GET",
				url: controllerUrl
			});
			getVideoData.then(function(response, xhr) {
				//var videoUrl = response.PublishedUrl;
				//var videoUrl = "https://4imprintvideo.streaming.mediaservices.windows.net/0002c5a1-340c-47fe-a14c-97ecce198f77/111699%20-%20Value%20White%20Mug%20-%20Promotional%20Products%20by%204imprint.ism/manifest";
				var videoMarkup = '<video id="azuremediaplayer" class="azuremediaplayer amp-flush-skin amp-big-play-centered embed-responsive-item" width="100%" height="100%" tabindex="0">' + '</video>';

				if (isDialog) {
					document.getElementById("videoContainer").innerHTML = videoMarkup;
					document.getElementById("videoDialog").getElementsByTagName("h2")[0].innerHTML = vidTitle;
				}

				if (typeof amp == 'function') {
					displayVideo(productVideoDialog, response.PublishedUrl, response.EnglishSubtitleUrl);
				} else {
					loadScript(displayVideo, productVideoDialog, response.PublishedUrl, response.EnglishSubtitleUrl);
				}
			});
		},
		displayVideo = function(videoDialog, videoUrl, subtitleUrl) {
			videoPlayer = amp("azuremediaplayer", videoOptions);
			if (subtitleUrl && subtitleUrl.length) {
				videoPlayer.src(
					[{ src: videoUrl, type: "application/vnd.ms-sstr+xml" }],
					[{ src: subtitleUrl, srclang: "en", kind: "subtitles", label: "English" }]
				);
			} else {
				videoPlayer.src(
					[{ src: videoUrl, type: "application/vnd.ms-sstr+xml" }]
				);
			}

			if (isDialog) {
				videoDialog.init(document.getElementById('videoDialog'));
				videoDialog.open();
				document.getElementsByClassName("close4iDialog")[0].addEventListener("click", closeDialog);
				document.getElementById("videoDialog").addEventListener("keydown", function(e) {
					if (e.keyCode === 27) { closeDialog(); }
				});
			}
		},
		loadScript = function(callback, videoDialog, videoUrl, subtitleUrl) {
			const head = document.head;

			const link = document.createElement('link')
			link.href = azureMediaPlayerSkinPath;
			link.type = 'text/css';
			link.rel = 'stylesheet';

			head.appendChild(link);

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = azureMediaPlayerPath;

			script.onload = (function() { callback(videoDialog, videoUrl, subtitleUrl) });

			head.appendChild(script);
		};

	return {
		allVideoLinks: allVideoLinks,
		initLinks: initLinks,
		initDynamicLink: initDynamicLink,
		initWhyBuyVideo: initWhyBuyVideo,
		initWeBelieveVideo: initWeBelieveVideo
	};
};